// extracted by mini-css-extract-plugin
export default {"main":"notfound_main__1+zDm","notfound":"notfound_notfound__AgpW1","title":"notfound_title__0AWLv","paragraph":"notfound_paragraph__mfrqS","link":"notfound_link__ed2w2"};